import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.css";
import "./style.css";
import Verify from "./pages/verify";
import Events from "./pages/Events";
import Header from "./components/Header";
import TabsHeading from "./components/Tabs/Tabsheading";
import Application from "./pages/Application";
import JobsPage from "./pages/JobsPage";

// Main app component with tabs (existing functionality)
const MainApp = () => {
  const [actTabHeader, SetActTabHeader] = useState("tokenization");
  const listheader = ["tokenization", "apply"];
  
  return (
    <>
      <div className="row m-0">
        <div   className={`main-content-area ${
    actTabHeader === "apply" ? "col-lg-12" : "col-lg-8"
  }`}
  style={{
    transition: "all 0.5s ease",
  }}>
  <Header actTabHeader={actTabHeader} />
          <div
            className="text-center mx-auto"
            style={{
              maxWidth: "100%",
              wordWrap: "break-word",
              whiteSpace: "normal",
              fontSize: "14px",
            }}
          >
            Use this playground to tokenize your data, create a registry, and
            manage it. Perform operations like create, verify, update, or revoke
            using&nbsp;
            <a
              href="https://github.com/dhiway/cord.js"
              target="_blank"
              rel="noopener noreferrer"
              className="text-decoration-underline text-body"
              style={{ textDecorationThickness: "1px" }}
            >
              CORD SDK ↗
            </a>
            .
          </div>

          <TabsHeading
            list={listheader}
            actTab={actTabHeader}
            setActTab={SetActTabHeader}
          />
          {actTabHeader === "tokenization" ? (
            <Verify />
          ) : (
            <Application />
          )}
        </div>
        {actTabHeader !== "apply" ? (
          <div   className={`col-lg-4 transition-opacity ${
            actTabHeader === "apply" ? "opacity-0 pointer-events-none" : "opacity-100"
          }`}
          style={{ transition: "opacity 0.5s ease" }}>
            <Events actTab={actTabHeader} list={listheader} />
          </div>
        ) : null}
      </div>
    </>
  );
};

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Main app route with existing tab functionality */}
        <Route path="/" element={<MainApp />} />
        
        {/* Jobs page route - standalone page without navigation */}
        <Route path="/jobs/:jobId" element={<JobsPage />} />
      </Routes>
    </Router>
  );
};

export default App;
